<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Lead Aging Analysis</b-card-title>
      </b-card-header>

      <!-- Bar Chart -->
      <apexchart
        type="bar"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "LeadTimeHistogram",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
 computed: {
  leadData() {
    const leadMap = new Map();
    this.data.forEach(({ ageGroup, leadCount }) => {
      leadMap.set(ageGroup, (leadMap.get(ageGroup) || 0) + leadCount);
    });

    return [...leadMap.entries()].map(([ageGroup, leadCount]) => ({
      ageGroup,
      leadCount
    }));
  },
  series() {
    return [{
      name: "Lead Time Distribution",
      data: this.leadData.map(item => item.leadCount)
    }];
  },
  chartOptions() {
    return {
      chart: {
        height: 350,
        type: "bar",
        zoom: { enabled: false }
      },
      dataLabels: {
        enabled: window.innerWidth > 768 // Hide data labels on smaller screens
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5
        }
      },
      xaxis: {
        categories: this.leadData.map(item => item.ageGroup),
        title: {
          text: "Lead Aging Groups"
        }
      },
      yaxis: {
        title: { text: "# of Leads" }
      },
      fill: { colors: ["#4e73df"] },
      tooltip: { theme: "dark" }
    };
  }
}

};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filters b-form-group {
  flex: 1;
  margin-right: 10px;
}
</style>
